/**
 * Saved views (CS r4b deliverable 122; baseline section 3, WORKSPACE): a named catalogue query of
 * one type with its columns and layout. Owner 2.K. A view has no `pinned` field: a live
 * `sidebar_item` of kind `view` naming it is the pin (open point 13), answered as `pinnedItemId`
 * and made by `views.pin`; unpinning is `sidebar.remove`. Requests take the layouts `table` and
 * `list`; an answer carries any of the seven `saved_view` holds.
 */
import { SAVED_VIEW_LAYOUTS, SAVED_VIEW_REQUEST_LAYOUTS } from '../domain/rows-enums.js';
import { z } from '../zod.js';
import { IsoTimestamp, RowVersion, Uuid } from './common.js';
import { TypeKey } from './documents.js';
import { CatalogueColumn, CatalogueQueryV1 } from './hygiene.js';
export { SAVED_VIEW_LAYOUTS, SAVED_VIEW_REQUEST_LAYOUTS };
/** A stored layout: baseline section 3's seven. */
export const SavedViewLayout = z.enum(SAVED_VIEW_LAYOUTS);
/** A layout a request may set: `table` or `list` (board, gallery and the rest are Phase 4). */
export const SavedViewRequestLayout = z.enum(SAVED_VIEW_REQUEST_LAYOUTS);
/** A view's name: at least one non-blank character. */
export const SavedViewName = z.string().min(1).max(200).regex(/\S/);
/** The columns a view shows, in order: catalogue columns, each a field key or a document column. */
export const SavedViewColumns = z.array(CatalogueColumn).max(64);
/** A saved view (`saved_view`), with the id of its live pin, if any. */
export const SavedViewV1 = z.strictObject({
    id: Uuid,
    rv: RowVersion,
    name: SavedViewName,
    typeKey: TypeKey,
    layout: SavedViewLayout,
    query: CatalogueQueryV1,
    columns: SavedViewColumns,
    /** The first live `sidebar_item` of kind `view` naming this view; null when it is not pinned. */
    pinnedItemId: Uuid.nullable(),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
/** `views.list`: every view, or one type's (an unknown key lists nothing). */
export const ViewsQueryV1 = z.strictObject({ typeKey: TypeKey.optional() });
/** `views.create`. */
export const SavedViewCreateV1 = z.strictObject({
    name: SavedViewName,
    typeKey: TypeKey,
    layout: SavedViewRequestLayout,
    query: CatalogueQueryV1,
    columns: SavedViewColumns,
});
/** `views.update`: the parts given change (rename is `name`), against the view's `rv`. */
export const SavedViewUpdateV1 = z.strictObject({
    baseRv: RowVersion,
    name: SavedViewName.optional(),
    layout: SavedViewRequestLayout.optional(),
    query: CatalogueQueryV1.optional(),
    columns: SavedViewColumns.optional(),
});
/** `views.pin`: pin at the end of a group, or of the top level when `parentId` is omitted. */
export const SavedViewPinV1 = z.strictObject({ parentId: Uuid.optional() });
//# sourceMappingURL=views.js.map